import { i18n } from "@lingui/core";
import { detect, fromHtmlTag } from "@lingui/detect-locale";

export async function activateI18n() {
    const locale = detect(fromHtmlTag("lang"), "en");

    const { messages } = await import(`../../locales/${locale}.mjs`);
    i18n.load(locale, messages);
    i18n.activate(locale);
}
